export interface MessageData {
  body: string;
  role: 'user' | 'assistant';
  isError?: boolean;
}

export interface ConversationSession {
  conversationId: string | null;
  messages: MessageData[];
  draft: string;
  initialSent: boolean;
  initialFailed: boolean;
  pending: boolean;
}

export const emptySession = (): ConversationSession => ({
  conversationId: null,
  messages: [],
  draft: '',
  initialSent: false,
  initialFailed: false,
  pending: false
});

export const readSession = (key: string | null): ConversationSession => {
  if (!key) return emptySession();
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (
      !value ||
      !Number.isFinite(value.savedAt) ||
      value.savedAt > Date.now() ||
      Date.now() - value.savedAt > 24 * 60 * 60 * 1000 ||
      !(
        value.conversationId === null ||
        (typeof value.conversationId === 'string' &&
          value.conversationId.trim())
      ) ||
      typeof value.draft !== 'string' ||
      typeof value.initialSent !== 'boolean' ||
      typeof value.initialFailed !== 'boolean' ||
      typeof value.pending !== 'boolean' ||
      !Array.isArray(value.messages) ||
      value.messages.length > 200 ||
      !value.messages.every(
        (item: MessageData) =>
          item &&
          typeof item.body === 'string' &&
          ['user', 'assistant'].includes(item.role) &&
          (item.isError === undefined || typeof item.isError === 'boolean')
      )
    ) {
      sessionStorage.removeItem(key);
      return emptySession();
    }
    // A reload cannot determine whether an interrupted POST reached the server.
    // Restore the draft and require the learner to choose the next attempt.
    return {
      ...value,
      pending: false,
      initialFailed:
        value.initialFailed || (value.pending && !value.initialSent)
    };
  } catch {
    return emptySession();
  }
};

export const writeSession = (
  key: string | null,
  value: ConversationSession
) => {
  if (!key) return;
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        ...value,
        messages: value.messages.slice(-200),
        savedAt: Date.now()
      })
    );
  } catch {
    // Storage can be unavailable or full; the active conversation still works.
  }
};
